<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <v-menu :close-on-content-click="false" offset-y min-width="auto">
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="dateBegin.date"
            v-bind="attrs"
            v-on="on"
            prepend-icon="mdi-calendar"
            label="Дата начала"
            readonly
            dense
          />
        </template>
        <v-date-picker v-model="dateBegin.date" />
      </v-menu>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-menu :close-on-content-click="false" offset-y min-width="auto">
        <template #activator="{ on, attrs }">
          <v-text-field
            label="Время начала"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            dense
            v-model="dateBegin.time"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-time-picker v-model="dateBegin.time" format="24hr" />
      </v-menu>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-menu :close-on-content-click="false" offset-y min-width="auto">
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="dateEnd.date"
            v-bind="attrs"
            v-on="on"
            prepend-icon="mdi-calendar"
            label="Дата окончания"
            readonly
            dense
            :rules="minDay"
          />
        </template>
        <v-date-picker v-model="dateEnd.date" />
      </v-menu>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-menu :close-on-content-click="false" offset-y min-width="auto">
        <template #activator="{ on, attrs }">
          <v-text-field
            label="Время окончания"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            dense
            v-model="dateEnd.time"
            v-bind="attrs"
            v-on="on"
            :rules="minTime"
          />
        </template>
        <v-time-picker v-model="dateEnd.time" format="24hr" />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PassInfoForm",
  props: { value: Object },

  data() {
    return {
      dateBegin: { date: null, time: null },
      dateEnd: { date: null, time: null },
      minDay: [
        () =>
          new Date(`${this.dateBegin.date}`) <=
            new Date(`${this.dateEnd.date}`) ||
          "Дата окончания не может быть раньше даты начала"
      ],
      minTime: [
        () =>
          new Date(`${this.dateBegin.date} ${this.dateBegin.time}`) <=
            new Date(`${this.dateEnd.date} ${this.dateEnd.time}`) ||
          "Время окончания не может быть раньше времени начала"
      ]
    };
  },

  watch: {
    value: {
      handler(v) {
        if (v) {
          this.dateBegin = this.dateStrToModel(v.dateStart);
          this.dateEnd = this.dateStrToModel(v.dateEnd);
        }
      },
      immediate: true
    },

    dateBegin: {
      handler(v) {
        this.$emit("input", {
          ...this.value,
          dateStart: new Date(`${v.date} ${v.time}`)
        });
      },
      deep: true
    },

    dateEnd: {
      handler(v) {
        this.$emit("input", {
          ...this.value,
          dateEnd: new Date(`${v.date} ${v.time}`)
        });
      },
      deep: true
    }
  },

  methods: {
    dateStrToModel(str) {
      const date = str ? new Date(str) : new Date();
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();

      return {
        date: [y, m, d].join("-"),
        time: date.toLocaleString().slice(11, 17)
      };
    }
  }
};
</script>
